var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlusSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#2A836B"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5 8h8v2H5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10 5v8H8V5z"
})));
export default SvgPlusSmall;